module.exports = {
      id: "comm-science-usage",
      viewBox: "0 0 366.545 49.888",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#comm-science",
      toString: function () {
        return this.url;
      }
    }